import { Type } from 'typebox';
import { AnswerCodec, AnswerTypeCodec, HealthTypeCodec } from '../health/health-screening.js';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const HealthEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.health),
        healthType: Type.Optional(HealthTypeCodec),
        screeningId: Type.Optional(Type.String({ minLength: 1 })),
        question: Type.Optional(Type.String()),
        questionId: Type.Optional(Type.String({ minLength: 1 })),
        answerType: Type.Optional(AnswerTypeCodec),
        answer: Type.Optional(Type.String()),
        ordinal: Type.Optional(Type.Integer()),
        alertOnAnswer: Type.Optional(AnswerCodec),
        required: Type.Optional(Type.Boolean())
    })
]));
